import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  maxWidth: theme.spacing(118.875),
  margin: 'auto',
  marginBottom: theme.spacing(17.5),
  textAlign: 'center',
  '& .FSTitle': {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(5),
  },
  '& .FSDesc': {
    color: theme.palette.common.fogWhite,
    margin: 'auto',
    marginBottom: theme.spacing(7),
    maxWidth: theme.spacing(56.25),
  },
  '& .FSInput': {
    backgroundColor: theme.palette.common.white,

    '& fieldset': {
      border: 'none',
    },
    '& .MuiInputBase-root': {
      color: theme.palette.common.grey,
      fontSize: theme.spacing(2),
      '& .MuiOutlinedInput-input': {
        padding: theme.spacing(3.75, 1.75, 1, 1.5),
      },
    },

    '&.FSEmailInput': {
      [theme.breakpoints.up('lg')]: {
        borderLeft: `1px solid  ${theme.palette.grey.concrete}`,
      },
    },
    '&.FSNameInput': {
      [theme.breakpoints.down('lg')]: {
        borderBottom: `1px solid  ${theme.palette.grey.concrete}`,
        borderRadius: theme.spacing(0.5, 0.5, 0, 0),
      },
    },
    '& .MuiFormLabel-root': {
      color: theme.palette.common.grey,
      fontSize: theme.spacing(2),
      top: theme.spacing(0.75),
      '&.MuiInputLabel-shrink': {
        transform: 'translate(13px, 2px) scale(0.8)',
      },
      '&.Mui-focused': {
        color: `${theme.palette.common.grey} !important`,
      },
    },
  },
  '& .FSSubBtn': {
    borderRadius: theme.spacing(0, 0, 0.5, 0.5),
    height: theme.spacing(7.5),
    textTransform: 'uppercase',
    [theme.breakpoints.up('lg')]: {
      height: '100%',
      borderRadius: theme.spacing(0, 0.5, 0.5, 0),
    },
  },
  '& .FSCaptcha': {
    visibility: 'hidden',
  },
}));

export default StyledBox;
